
import React from 'react';
import { useForm } from 'react-hook-form';
import { gstnAction, gstnameAction } from './Redux/Feature/EmailSlice';
import { useDispatch, useSelector } from 'react-redux';

const GstPopup = ({ handleClose }) => {
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm();
  const dispatch = useDispatch();


  const storesel = useSelector((state) => state);

  const gstnRedux = storesel.emailData?.gstn;
  const gstnameRedux = storesel.emailData?.gstname;

  const onSubmit = data => {
    // const regex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][1-9A-Z]{1}Z[0-9A-Z]{1}$/;
    // if (!regex.test(data.gstn)) {
    //   return;
    // }
    dispatch(gstnAction(data.gstn));
    dispatch(gstnameAction(data.gstname));
    handleClose();
  };

  return (
    <div className="gst-popup">
      <div className="gst-popup-inner">
        <button className="gst-close-btn" onClick={handleClose}>
          &times;
        </button>
        <h2>Gst Details</h2>
        <form onSubmit={handleSubmit(onSubmit)}>
          <input
            className='gst-input'
            defaultValue={gstnRedux ? gstnRedux : ''}
            {...register("gstn", {
              required: 'GST number is required',
              pattern: {
                value: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][0-9A-Z]{1}[A-Z][0-9A-Z]{1}$/,
                message: 'Please enter a valid GST Number'
              }
            })}
            placeholder="Gst Number"
          />

            {errors.gstn && <p style={{ color: 'red' }}>{errors.gstn.message}</p>}
          <input
              defaultValue={gstnameRedux ? gstnameRedux : ''}

            className='gst-input'
            {...register("gstname")}
            placeholder="Gst Name"
          />
          <br />
          <button className='gst-submit-button' type="submit">Save</button>
        </form>
      </div>
    </div>
  );
};

export default GstPopup;
